import {AnyAction} from "redux";
import {SET_SELECTED_POWER_SOURCE, REMOVE_POWER_SOURCE, ADD_POWER_SOURCE_AT_LOCATION, REMOVE_ALL_POWER_SOURCES, SET_DRAGGING_POWER_SOURCE, PLACE_POWER_SOURCE, RESET_ALL_POWER_SOURCES} from "./action";
import {IPowerSource} from "../../data/data";


/**
 * select a power source to add to a location
 * @param power_source
 * @return {{type: string, payload: {power_source: IPowerSource}}}
 */
export function selectPowerSource(power_source: IPowerSource) : AnyAction
{
    return {type: SET_SELECTED_POWER_SOURCE, payload: {power_source}};
}


/**
 * set the power source currently being dragged
 * @param power_source
 * @param ox
 * @param oy
 */
export function setDraggingPowerSource(power_source: IPowerSource = null, ox: number = null, oy: number = null) : AnyAction
{
    return {type: SET_DRAGGING_POWER_SOURCE, payload: {power_source, ox, oy}};
}


// /**
//  * add a power source to a location
//  * @param power_source
//  * @param location_id
//  * @return {{type: string, payload: {power_source: IPowerSource, location_id: number}}}
//  */
// export function addPowerSource(power_source: IPowerSource, location_id: number) : AnyAction
// {
//     return {type: ADD_POWER_SOURCE_AT_LOCATION, payload: {power_source, location_id}};
// }


/**
 * place the dragged power source at the highlighted location
 */
export function placePowerSource() : AnyAction
{
    return {type: PLACE_POWER_SOURCE};
}


/**
 * add a power source to a location
 * @param power_source
 * @param location_id
 * @return {{type: string, payload: {power_source: IPowerSource, location_id: number}}}
 */
export function addPowerSourceAtLocation(power_source: IPowerSource, location_id: number) : AnyAction
{
    return {type: ADD_POWER_SOURCE_AT_LOCATION, payload: {power_source, location_id}};
}


/**
 * remove a power source
 * @param location_id
 * @return {{type: string, payload: {location_id: number}}}
 */
export function removePowerSourceAtLocation(location_id: number) : AnyAction
{
    return {type: REMOVE_POWER_SOURCE, payload: {location_id}};
}


/**
 * remove all power sources
 */
export function removeAllPowerSources() : AnyAction
{
    return {type: REMOVE_ALL_POWER_SOURCES, payload: {}};
}


/**
 * remove all power sources
 */
export function resetAllPowerSources() : AnyAction
{
    return {type: RESET_ALL_POWER_SOURCES, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/powerSources.ts